(function($) {

  $.Control.extend(
    'pane_queryEditorDisabled',
    {
      isAvailable: function() {
        return true;
      },

      getTitle: function() {
        return $.t('screens.ds.grid_sidebar.query_editor_disabled.title');
      },

      getSubtitle: function() {
        return $.t('screens.ds.grid_sidebar.query_editor_disabled.subtitle');
      },

      getDisabledSubtitle: function() {
        return '';
      },

      _getSections: function() {
        return [];
      },

      _getFinishButtons: function() {
        return [];
      },

      // Arguments provided to this method: 'data', 'value', 'finalCallback'
      _finish: function() {}
    },
    { name: 'queryEditorDisabled' },
    'controlPane'
  );

  $(document).ready(function() {
    var showPane = _.get(window, 'socrata.gridView.sidebarPaneVisibility.filter.soqlQueryEditorDisabled', false);

    if (showPane) {
      $.gridSidebar.registerConfig('filter.queryEditorDisabled', 'pane_queryEditorDisabled', 1);
    }
  });
})(jQuery);
